import { IClientsRequest } from 'schemas';

import { ESortDirection } from '../interfaces';

export const VARIABLES: IClientsRequest = {
  input: {
    q: '',
    sort: {
      field: 'last_client_activity',
      direction: ESortDirection.DESC,
    },
  },
  first: 25,
  page: 1,
};
